import { useRef } from "react";
import Form from "react-bootstrap/Form";
import { Formik, FormikProps } from "formik";
import * as Yup from "yup";

//Common
import FormBackGround from "../common/Forms/FormBackGround/FormBackGround";
import FormHeader from "../common/Forms/FormHeader/FormHeader";
import TextField from "../common/VFX-UI/TextField/TextField";
import { MaskedPhoneNumberField } from "../common/VFX-UI/Mask/Mask";
import ActionBar from "../common/ActionBar/ActionBar";

//App
import { UserFormProps } from "../../types";
import { yupValidatePhone } from "../../utility/helpers/yupValidation";
import { useQuery } from "@tanstack/react-query";
import userApi from "../../app/model/api/userApi";
import { queryKeys } from "./constants";
import { Autocomplete, Chip } from "../common/VFX-UI";

const validationSchema = Yup.object({
  firstName: Yup.string().required("The first name is required."),
  lastName: Yup.string().required("The last name is required."),
  email: Yup.string()
    .email("Enter a valid email")
    .required("Email is required."),
  phoneNumber: yupValidatePhone().required("Phone number is required."),
});

const ProfileForm = (props: UserFormProps) => {
  const { status, initialVal, onClose, handleOnSubmit } = props;
  const formRef = useRef<FormikProps<any>>(null);
    
  const title = "User Profile";

  const { data: userLookupData } = useQuery({
    queryKey: [queryKeys.getUserLookups],
    queryFn: () => userApi.getLookups(),
  });
  let lookupOptions: any = [];
  if (userLookupData?.result) {
    lookupOptions = userLookupData?.result?.map((item: any) => ({
      value: item.id,
      label: item.name,
    }));
  }
  const saveInput = () => {
    if (formRef.current) {
      formRef.current.handleSubmit();
    }
  };

  return (
    <FormBackGround>
      <FormHeader title={title} onClose={onClose} />
      <Formik
        onSubmit={handleOnSubmit}
        initialValues={initialVal}
        validationSchema={validationSchema}
        innerRef={formRef}
      >
        {({ values }) => (
          <Form noValidate>
            <div className="d-flex justify-content-end mb-3 me-3">
              <Chip label={values.isActive ? "Active" : "Inactive"} />
            </div>
            <TextField
              label="First Name"
              type="text"
              name="firstName"
              isRequired={true}
            />
            <TextField
              label="Last Name"
              type="text"
              name="lastName"
              isRequired={true}
            />
            <Autocomplete
              disabled={true}
              name="roleId"
              label="Role"
              isRequired={true}
              options={lookupOptions ?? []}
              defaultSelected={
                initialVal.roleId != null && initialVal.roleId.length > 0
                  ? [initialVal.roleId[0]]
                  : []
              }
            />
            <TextField
              label="Email Address"
              type="text"
              name="email"
              isRequired={true}
              disabled={true}
            />
            <MaskedPhoneNumberField
              name="phoneNumber"
              label="Phone Number"
              isRequired={true}
            />
            <ActionBar
              submitHandler={saveInput}
              cancelHandler={onClose}
              submitText="Save"
              cancelText="Cancel"
              isLoading={status === "pending"}
            ></ActionBar>
          </Form>
        )}
      </Formik>
    </FormBackGround>
  );
};

export default ProfileForm;
